import { Question, QuestionAnswer } from '@pbt/pbt-ui-components'

export const hasSelectedAnswers = (answers: QuestionAnswer[]) =>
  answers.some((answer) => answer.selected)

export const hasQuestionWithSelectedAnswer = (questions: Question[]) =>
  questions.some(({ answers }) => hasSelectedAnswers(answers))
